/* ============================================================
   MOSAIK — L'AIDE

   Deux aides, une seule mécanique :

     - LE GUIDE (bouton « ? » au-dessus du plan) — la page dans son ensemble,
       racontée dans l'ORDRE OÙ ON S'EN SERT : le modèle, les cotes, la forme de
       la pièce, la couleur, les remplissages, les bordures, le déplacement dans
       le plan, puis l'enregistrement. Une étape à l'écran à la fois : la page a
       huit choses à faire, les lire toutes d'un coup n'apprend rien.

     - LA FICHE D'UN MENU (bouton « ? » sur chaque carte de la barre latérale) —
       le détail de CE réglage-là, en trois ou quatre lignes. C'est là que vont
       les règles qui ne se devinent pas (la gomme travaille dans les deux sens,
       deux choix de couleur définissent le damier, changer de gamme repart d'un
       plan vierge…). Le guide, lui, reste au fil conducteur.

   Le texte est court PAR CONSTRUCTION : une aide qu'on lit est une aide de
   quelques lignes. Tout ce qui tient sur l'écran est écrit sur l'écran (les
   libellés des boutons, les infobulles) — on ne le répète pas ici.

   Rien dans le gabarit hormis les boutons : le cadre est construit ici, comme
   les autres popups de la page (voir confirmDialog dans mosaik-mytemplates.js).
   Les textes sont en anglais — la source — et traduits par MOSAIK_L10N
   (mosaik-data.js), comme partout ailleurs.
   ============================================================ */
window.MosaikHelp = {

  m: null,
  _ov: null,               // l'habillage ouvert, ou null
  _body: null,             // la zone dont le contenu change d'une étape à l'autre
  _step: 0,

  /* ---- le guide : la page, étape par étape ----
     L'ordre est celui de la barre latérale, qui est celui du travail : on
     choisit sa dalle avant de mesurer, on mesure avant de découper, on découpe
     avant de colorer. */
  TOUR: [
    { t:'Your model',
      b:['Pick your tile range: it sets the tile size, its thickness and the colours you can use.',
         'Changing range starts again from a blank plan.'] },
    { t:'Your overall dimensions',
      b:['Enter the width and the length of your floor, in metres.',
         'The plan uses whole tiles only, and is redrawn as soon as a figure changes.'] },
    { t:'Adjust your space',
      b:['Your room is not a rectangle? "Remove / Add tiles" takes out the tiles you do not need — a pillar, a step, a doorway.',
         'The same tool puts them back: start on an empty tile instead of a full one.'] },
    { t:'Choose a colour, paint a tile',
      b:['In "Tiles", click a colour, then click the tiles of the plan.',
         'Drag without releasing to paint several tiles in a row.'] },
    { t:'Fill in one go',
      b:['"Solid color" and "Checkerboard colors" fill the whole plan at once.',
         'Two successive colour picks set the two checkerboard colours.',
         'Outline a zone first, and both buttons only fill that zone.'] },
    { t:'Borders and corners',
      b:['Open "Borders and corners", pick a colour, then click a border or a corner around the plan.',
         'Ranges that offer none simply do not show the card.'] },
    { t:'Move around the plan',
      b:['Zoom with the wheel or the − / + buttons; "Fit to view" shows the whole plan again.',
         'On a phone: one finger paints, two fingers move the plan, a pinch zooms.',
         'The two arrows over the plan undo and redo.'] },
    { t:'Save and order',
      b:['"Save" keeps the design under your account — you find it again in "My projects".',
         '"PDF" gives you a quote to keep, "Add to cart" orders exactly what is drawn.'] }
  ],

  /* ---- la fiche de chaque menu ----
     Clé = l'id de la carte, ce que le bouton porte en `data-help`. */
  CARDS: {
    'mosaik-card-model': { t:'Your model', b:[
      'The range sets the tile size, its thickness and the colours available.',
      'The button reopens the setup window — the only place to switch range.',
      'Beware: switching range clears the plan and starts over.'] },

    'mosaik-card-dims': { t:'Your overall dimensions', b:[
      'The length (↑) and the width (→) of your floor, in metres.',
      'The plan covers that area with WHOLE tiles: it stops at the last full one.',
      'Changing a figure redraws the plan from blank.'] },

    'mosaik-card-space': { t:'Adjust your space', b:[
      '"Remove / Add tiles" is a switch: one click to enter, one more to leave.',
      'The first tile you touch sets the direction — a full tile is removed, an empty one comes back.',
      'Drag to clear a whole row in one move.'] },

    'mosaik-card-tiles': { t:'Tiles', b:[
      'Click a colour, then the tiles of the plan; drag to paint several.',
      '"Solid color" fills everything with the selected colour.',
      '"Checkerboard colors" alternates the last TWO colours you picked.',
      '"Select a zone" limits both fills to the part you outline.'] },

    'mosaik-card-edges': { t:'Borders and corners', b:[
      'Pick a colour, then click a border or a corner on the edge of the plan.',
      'The eraser removes one: switch to it and click the border again.'] },

    'mosaik-card-objects': { t:'Parking spaces and accessories', b:[
      'Drag an item from here onto the plan — or tap it, then tap the plan.',
      'A parking space is an outline one tile thick: it recolours the tiles it covers, and gives them back their colour when you remove it.',
      'Grab a dropped item by its outline (or its centre dot) to move it; its two handles turn it and remove it.',
      'Accessories, such as the hexagonal lights, hang from the ceiling: they cost extra and appear in the details.'] },

    'mosaik-card-templates': { t:'Browse templates', b:[
      'Ready-made patterns, applied to YOUR dimensions — a template imposes none of its own.',
      'It replaces the current design, and asks before doing so.',
      'A pattern that needs more tiles than your floor has is refused.'] },

    'mosaik-card-projects': { t:'My projects', b:[
      '"Save", in the bottom bar, keeps the plan under your account.',
      'An account is needed: logged out, the button leads to the login page.',
      'Click a saved design to load it back into the plan.'] }
  },

  t:function(s){ return (this.m && this.m.getText) ? this.m.getText(s) : s; },

  setup:function(mosaik){
    this.m = mosaik;
    const self = this;
    const open = document.getElementById('mosaik-help-open');
    if(open) open.addEventListener('click', () => self.openTour());
    // le « ? » de chaque carte. Il est POSÉ À CÔTÉ du bandeau pliable, pas
    // dedans : un bouton dans un bouton n'existe pas, et son clic replierait la
    // carte au moment où l'on demande à la comprendre.
    document.querySelectorAll('#mosaik-sidebar [data-help]').forEach(btn => {
      btn.addEventListener('click', () => self.openCard(btn.getAttribute('data-help')));
    });
    this.localize();
  },

  localize:function(){
    const open = document.getElementById('mosaik-help-open');
    if(open){
      const s = this.t('How does this page work?');
      open.title = s; open.setAttribute('aria-label', s);
    }
    const self = this;
    document.querySelectorAll('#mosaik-sidebar [data-help]').forEach(btn => {
      const card = self.CARDS[btn.getAttribute('data-help')];
      const s = card ? self.t(card.t) : self.t('Help');
      btn.title = s; btn.setAttribute('aria-label', s);
    });
  },

  /* ---- le cadre, commun aux deux aides ----
     Ouvert une fois ; ce sont seulement ses ENTRAILLES qui changent quand on
     passe d'une étape à la suivante — sinon le popup clignoterait à chaque
     « Suivant ». */
  _shell:function(){
    if(this._ov) return this._body;
    const self = this;
    const ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(36,51,58,.55);z-index:10002;'
      + 'display:flex;align-items:center;justify-content:center;padding:18px;box-sizing:border-box;'
      + 'opacity:0;transition:opacity .18s;';

    const card = document.createElement('div');
    card.style.cssText = 'background:#fff;max-width:470px;width:100%;max-height:100%;box-sizing:border-box;'
      + 'border-radius:18px;padding:22px 22px 18px;display:flex;flex-direction:column;'
      + 'box-shadow:0 18px 50px rgba(0,0,0,.28);font-family:Arial,Helvetica,sans-serif;'
      + 'transform:translateY(10px);transition:transform .18s;';

    // la croix, en haut à droite, hors du contenu qui défile
    const close = document.createElement('button');
    close.type = 'button';
    close.innerText = '✕';
    close.setAttribute('aria-label', this.t('Close'));
    close.style.cssText = 'position:absolute;top:14px;right:14px;width:32px;height:32px;padding:0;border:0;'
      + 'border-radius:50%;background:#f1f5f7;color:#6a7a82;font-size:15px;line-height:1;cursor:pointer;'
      + 'display:inline-flex;align-items:center;justify-content:center;transition:all .15s;';
    close.onmouseover = () => { close.style.background = '#e2ebef'; close.style.color = '#2c6b86'; };
    close.onmouseout  = () => { close.style.background = '#f1f5f7'; close.style.color = '#6a7a82'; };
    close.addEventListener('click', () => self.close());
    card.style.position = 'relative';
    card.appendChild(close);

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;min-height:0;';
    card.appendChild(body);

    ov.appendChild(card);
    document.body.appendChild(ov);
    // fermeture : le fond, et Échap. Les flèches feuillettent le guide.
    ov.addEventListener('click', e => { if(e.target === ov) self.close(); });
    this._onKey = e => {
      if(e.key === 'Escape'){ self.close(); return; }
      if(!self._tour) return;
      if(e.key === 'ArrowRight') self.go(self._step + 1);
      else if(e.key === 'ArrowLeft') self.go(self._step - 1);
    };
    document.addEventListener('keydown', this._onKey);
    requestAnimationFrame(() => { ov.style.opacity = '1'; card.style.transform = 'none'; });

    this._ov = ov; this._body = body;
    return body;
  },

  close:function(){
    const ov = this._ov;
    if(!ov) return;
    this._ov = null; this._body = null; this._tour = false;
    document.removeEventListener('keydown', this._onKey);
    ov.style.opacity = '0';
    setTimeout(() => { if(ov.parentNode) ov.parentNode.removeChild(ov); }, 180);
  },

  /* ---- les briques de contenu ---- */
  _title:function(text, badge){
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:11px;padding-right:34px;margin-bottom:4px;';
    const b = document.createElement('span');
    b.style.cssText = 'flex:0 0 auto;width:32px;height:32px;border-radius:50%;background:#eaf2f6;'
      + 'color:#699bb4;font-weight:800;font-size:.95em;display:inline-flex;align-items:center;justify-content:center;';
    b.innerText = badge;
    const h = document.createElement('div');
    h.style.cssText = 'font-size:1.12em;font-weight:700;color:#3a4a52;line-height:1.3;';
    h.innerText = text;
    row.appendChild(b); row.appendChild(h);
    return row;
  },

  /* Les lignes de l'explication : une puce ronde et pâle par ligne, pour qu'on
     voie d'un coup d'œil qu'il y en a trois et non un paragraphe. */
  _lines:function(arr){
    const box = document.createElement('div');
    box.style.cssText = 'margin-top:14px;overflow-y:auto;min-height:0;';
    const self = this;
    arr.forEach(s => {
      const li = document.createElement('div');
      li.style.cssText = 'display:flex;gap:10px;margin-bottom:10px;color:#5b6b73;font-size:.95em;line-height:1.5;';
      const dot = document.createElement('span');
      dot.style.cssText = 'flex:0 0 auto;width:6px;height:6px;border-radius:50%;background:#c3d4dd;margin-top:8px;';
      const p = document.createElement('span');
      p.innerText = self.t(s);
      li.appendChild(dot); li.appendChild(p);
      box.appendChild(li);
    });
    return box;
  },

  _btn:function(label, primary, onClick){
    const b = document.createElement('button');
    b.type = 'button';
    b.innerText = label;
    b.style.cssText = primary
      ? 'background:#699bb4;color:#fff;border:0;min-height:44px;border-radius:24px;font-weight:700;'
        + 'padding:10px 26px;cursor:pointer;font-size:.98em;font-family:inherit;'
        + 'box-shadow:0 8px 20px rgba(105,155,180,.28);transition:all .15s;'
      : 'background:#fafafa;color:#666;border:2px solid #ccc;min-height:44px;border-radius:24px;font-weight:700;'
        + 'padding:10px 20px;cursor:pointer;font-size:.98em;font-family:inherit;transition:all .15s;';
    b.onmouseover = () => { if(primary) b.style.background = '#5a8aa2';
                            else { b.style.borderColor = '#699bb4'; b.style.color = '#2c6b86'; } };
    b.onmouseout  = () => { if(primary) b.style.background = '#699bb4';
                            else { b.style.borderColor = '#ccc'; b.style.color = '#666'; } };
    b.addEventListener('click', onClick);
    return b;
  },

  /* ---- le guide ---- */
  openTour:function(step){
    this._tour = true;
    this._shell();
    this.go(step || 0);
  },

  go:function(i){
    if(!this._body) return;
    const n = this.TOUR.length;
    this._step = Math.max(0, Math.min(n - 1, i));
    const s = this.TOUR[this._step], self = this;
    const body = this._body;
    body.innerHTML = '';

    body.appendChild(this._title(this.t(s.t), String(this._step + 1)));

    // le compteur : on sait toujours combien il en reste, donc si l'on peut
    // s'arrêter là
    const count = document.createElement('div');
    count.style.cssText = 'margin-left:43px;color:#9aa7ad;font-size:.8em;font-weight:700;'
      + 'letter-spacing:.04em;text-transform:uppercase;';
    count.innerText = this.t('Step') + ' ' + (this._step + 1) + ' / ' + n;
    body.appendChild(count);

    body.appendChild(this._lines(s.b));

    // les pastilles : un repère d'avancement, et un raccourci pour revenir à une
    // étape déjà lue sans repasser par « Précédent »
    const dots = document.createElement('div');
    dots.style.cssText = 'display:flex;gap:6px;justify-content:center;margin:6px 0 16px;flex-wrap:wrap;';
    this.TOUR.forEach((st, k) => {
      const d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', self.t('Step') + ' ' + (k + 1));
      d.style.cssText = 'width:9px;height:9px;padding:0;border:0;border-radius:50%;cursor:pointer;'
        + 'transition:background .15s;background:' + (k === self._step ? '#699bb4' : '#dfe7eb') + ';';
      d.addEventListener('click', () => self.go(k));
      dots.appendChild(d);
    });
    body.appendChild(dots);

    const actions = document.createElement('div');
    actions.style.cssText = 'display:flex;gap:10px;justify-content:space-between;align-items:center;';
    const prev = this._btn(this.t('Previous'), false, () => self.go(self._step - 1));
    prev.disabled = this._step === 0;
    if(prev.disabled){ prev.style.opacity = '.35'; prev.style.cursor = 'default'; prev.onmouseover = null; }
    const last = this._step === n - 1;
    const next = this._btn(last ? this.t('Finish') : this.t('Next'), true,
                           () => last ? self.close() : self.go(self._step + 1));
    actions.appendChild(prev); actions.appendChild(next);
    body.appendChild(actions);
  },

  /* ---- la fiche d'un menu ---- */
  openCard:function(id){
    const card = this.CARDS[id];
    if(!card) return;
    this._tour = false;
    const body = this._shell();
    const self = this;
    body.innerHTML = '';
    body.appendChild(this._title(this.t(card.t), '?'));
    body.appendChild(this._lines(card.b));
    const actions = document.createElement('div');
    actions.style.cssText = 'display:flex;gap:10px;justify-content:flex-end;margin-top:6px;';
    actions.appendChild(this._btn(this.t('Got it'), true, () => self.close()));
    body.appendChild(actions);
  }
};

/* Accessoires (luminaires) hors vente — voir la fin de mosaik-objects.js : la
   fiche ne parle alors que des emplacements véhicule. */
if (window.MOSAIK_ACCESSORIES_ENABLED !== true) {
  const c = window.MosaikHelp.CARDS['mosaik-card-objects'];
  c.t = 'Parking spaces';
  c.b = c.b.filter(s => s.indexOf('Accessories') !== 0);
}
